import { GET_DASHBOARD_API_URL } from "../components/Shared/constant";

const GetDashboard = async (accessToken) => {
    const responce = window.axios.get(`${GET_DASHBOARD_API_URL}`, {
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + accessToken,
    }}).then(function (result) {
        return {
          ...result.data,
          status:200
        };
    }).catch(function (result) {
        return {
          ...result?.response?.data,
          status:result?.response?.status
        }
    });
    return responce;
};
  
export default GetDashboard;